module.exports = __webpack_public_path__ + "img/Symbol_1.839a7644.png";